var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { useSidebarContext } from '../sidebar-context';
import { useTheme } from '../../theme/use-theme';
import { styled } from '../../styled';
import { Fade } from '../../transitions';
export var sidebarBannerComponentName = 'QuantumSidebarBanner';
var Root = styled('div', { name: sidebarBannerComponentName })(function (_a) {
    var theme = _a.theme;
    return (__assign(__assign({}, theme.typography.caption), { padding: theme.spacing(1.5, 2), margin: theme.spacing(2, 0), borderRadius: 6, backgroundColor: theme.tokens.color_bg_layer_alternate, color: theme.tokens.color_fg_default }));
});
export var SidebarBanner = React.forwardRef(function (props, ref) {
    var children = props.children, _a = props.FadeProps, FadeProps = _a === void 0 ? {} : _a, rootProps = __rest(props, ["children", "FadeProps"]);
    var theme = useTheme();
    var sidebarCollapsed = useSidebarContext().collapsed;
    return (React.createElement(Fade, __assign({ in: !sidebarCollapsed, style: {
            transitionDelay: !sidebarCollapsed ? "".concat(theme.transitions.duration.enteringScreen * 1.5, "ms") : undefined,
        }, timeout: { enter: theme.transitions.duration.enteringScreen, exit: 0 }, unmountOnExit: true }, FadeProps),
        React.createElement(Root, __assign({ ref: ref }, rootProps), children)));
});
